import { AppEnvironment, Config } from '@packages/shared/interfaces';
import { Platform } from '@packages/shared/core/common/entities';
import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { CookiesService } from '@packages/shared/core/common/services/cookies';
import { AppEnvironmentService } from './AppEnvironmentService';

export class AppEnvironmentServerService implements AppEnvironmentService {
  private config: Config;
  private logger: Logger;
  private cookiesService: CookiesService;

  constructor(config: Config, logger: Logger, cookies: CookiesService) {
    this.config = config;
    this.logger = logger;
    this.cookiesService = cookies;
  }

  isTestingEnv() {
    return false;
  }

  isApple() {
    return false;
  }

  isProductionEnv() {
    return this.config.env === AppEnvironment.PRODUCTION;
  }

  hasMatchMedia() {
    return false;
  }

  createMediaQuery() {
    return null;
  }

  isAndroid() {
    return false;
  }

  isAppleMobile() {
    return false;
  }

  isInAppBrowser() {
    return false;
  }

  getPlatform(): Platform {
    return 'unknown';
  }

  getSplitId() {
    return '';
  }
}
